import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { FullWidthBannerColorPalette } from '../../interfaces/fullWidthBanner';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import { HdHoverTracker } from '../../../analytics/components/hover-tracker/HoverTracker';
import { HdIcon, HdIconButton } from '../../../components';
import styles from './FullWidthBanner.module.scss';

export interface FullWidthBannerProps {
  open: boolean;
  dataId: string;
  className?: string;
  icon?: string;
  iconClass?: string;
  iconSrc?: string;
  canClose?: boolean;
  hoverTrackingAction?: string;
  hoverTrackingProps?: any;
  closeHoverTrackingAction?: string;
  closeHoverTrackingProps?: any;
  color: FullWidthBannerColorPalette;
  Title?: any;
  Action?: any;
  onClose?: Function;
  children?: ReactNode;
}

export function FullWidthBanner({
  open,
  dataId,
  className = '',
  icon,
  iconClass,
  iconSrc,
  canClose,
  hoverTrackingAction,
  hoverTrackingProps,
  closeHoverTrackingAction,
  closeHoverTrackingProps,
  color,
  Title,
  Action,
  onClose,
  children
}: FullWidthBannerProps) {
  if (!open) {
    return null;
  }

  const dataIdGenerator = getDataIdGenerator(dataId, 'banner');

  return (
    <HdHoverTracker trackingAction={hoverTrackingAction} trackingProps={hoverTrackingProps}>
      <div
        className={clsx(styles.banner, styles[color], className)}
        data-id={dataIdGenerator('')}
      >
        <div className='center-flex-row'>
          {icon && !iconSrc ? (
            <HdIcon name={icon} className={clsx(styles.bannerThumbnail, iconClass)} />
          ) : null}

          {iconSrc ? (
            <img
              src={iconSrc}
              className={styles.bannerThumbnail}
              alt=''
              data-id={dataIdGenerator('icon')}
            />
          ) : null}

          <div className='ml-2'>
            {Title ? <div className={styles.bannerTitle}>{Title}</div> : null}

            {children ? <div className={styles.bannerContent}>{children}</div> : null}
          </div>

          {Action || null}
        </div>

        {canClose ? (
          <HdHoverTracker
            trackingAction={closeHoverTrackingAction}
            trackingProps={closeHoverTrackingProps}
            dataId={dataIdGenerator('close-hover-tracker')}
          >
            <HdIconButton
              dataId={dataIdGenerator('close')}
              className={styles.closeBanner}
              onClick={() => onClose()}
            >
              <HdIcon name='close' />
            </HdIconButton>
          </HdHoverTracker>
        ) : null}
      </div>
    </HdHoverTracker>
  );
}
